<template>
  <pf-empty-state v-if="result === 0 && (!order?.stato || order?.stato === 'concluso')">
    <pf-empty-state-header :title="success" heading-level="h4">
      <template #icon>
        <pf-empty-state-icon>
          <check-icon />
        </pf-empty-state-icon>
      </template>
    </pf-empty-state-header>
    <pf-empty-state-body v-if="message">
      {{ message }}
    </pf-empty-state-body>
    <pf-empty-state-footer>
      <pf-empty-state-actions>
        <router-link v-if="link" :to="{name: route}">
          <arrow-left-icon />
          {{ link }}
        </router-link>
      </pf-empty-state-actions>
    </pf-empty-state-footer>
  </pf-empty-state>

  <template v-else>
    <pf-alert v-if="result === 1" :title="canceled" />

    <pf-alert
      v-else-if="result !== undefined && !isNaN(result)"
      variant="danger"
      :title="result == 2 ? rejected : unexpectedError"
    >
      <template v-if="error">{{ error }}</template>
    </pf-alert>

    <router-link v-if="link && result !== undefined && !isNaN(result)" :to="{name: route}">
      <arrow-left-icon />
      {{ link }}
    </router-link>

    <slot />
  </template>
</template>

<script lang="ts" setup>
import { $t } from '@/i18n';
import type { HTMLAttributes } from 'vue';
import CheckIcon from '@vue-patternfly/icons/check-icon';
import ArrowLeftIcon from '@vue-patternfly/icons/arrow-left-icon';

interface Props extends /* @vue-ignore */ HTMLAttributes {
  result?: number;
  success?: string;
  message?: string;
  canceled?: string;
  rejected?: string;
  unexpectedError?: string;
  error?: string | undefined | null;
  route: string;
  link?: string | undefined | null;
  order?: {
    stato?: string;
  };
}

withDefaults(defineProps<Props>(), {
  canceled: $t('Transazione annullata.'),
  rejected: $t('Transazione rifiutata.'),
  unexpectedError: $t('Errore inatteso.'),
});
</script>
